import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledTab = styled.div`
  width: 100%;
  > div {
    min-height: 0;
  }

  > div:first-child {
    margin-bottom: ${(props) => props.theme.size.static250};
  }

  > div > div {
    column-gap: ${(props) => props.theme.size.static250};
    padding: 0;
    margin-block: 0;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    > div:first-child {
      margin-bottom: ${(props) => props.theme.size.static300};
    }
  }
  @media (min-width: ${Breakpoints.b1600}px) {
    > div:first-child {
      margin-bottom: ${(props) => props.theme.size.static350};
    }
  }
`;
